import api from 'api';
import { useQuery } from 'react-query';
import { AppError } from 'utils/AppError';
import { salaryStructureQueries } from '../constants';

type UseListSalaryStructuresProps = {
  enabled?: boolean;
};

const useListSalaryStructures = ({ enabled }: UseListSalaryStructuresProps) => {
  const query = useQuery({
    queryKey: [salaryStructureQueries.getSalaryStructuresList],
    enabled,
    queryFn: async () => {
      const result = await api.salaryStructures.queries.listSalaryStructures({
        input: {
          status: 'SALARY_STRUCTURE_STATUS_ACTIVE',
        },
      });
      return result.payrollListSalaryStructures.data.salaryStructures;
    },
    onError: (error: AppError) => {},
  });

  return query;
};

export default useListSalaryStructures;
